// removed by extract-text-webpack-plugin
module.exports = {"jumbo":"src-components----Events-module---jumbo---lKice","content":"src-components----Events-module---content---19dyn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Events.module.css
// module id = 65
// module chunks = 32548347793320 35783957827783 38187647151852